import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from '@/components/ui/alert-dialog'
import { useDeleteView } from '@/hooks/use-views'
import { showSuccess, showError } from '@/lib/toast'
import type { ViewEntityType } from '@/types/api'

interface DeleteViewDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  viewId: string
  viewName: string
  entityType: ViewEntityType
  onSuccess?: () => void
}

export function DeleteViewDialog({
  open,
  onOpenChange,
  viewId,
  viewName,
  entityType,
  onSuccess,
}: DeleteViewDialogProps) {
  const deleteView = useDeleteView(entityType)

  const handleDelete = async () => {
    try {
      await deleteView.mutateAsync(viewId)
      showSuccess('View deleted successfully')
      onOpenChange(false)
      onSuccess?.()
    } catch (error) {
      console.error('Failed to delete view:', error)
      showError('Failed to delete view')
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-[400px]">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete View</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete "{viewName}"? This action cannot be
            undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleteView.isPending}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={deleteView.isPending}
            className="bg-destructive text-white hover:bg-destructive/90"
          >
            {deleteView.isPending ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
